import React from "react"
import TitleBlock from "../TitleBlock"

export default function AnnouncementEfp(props) {
  const { className, date, link, title } = props
  return (
    <div className={`AnnouncementEfp ${className}`}>
      <TitleBlock
        className="Certification-title-block"
        title={title}
        icon="d-none"
      />
      <span className="AnnouncementEfp-date">{date}</span>
      {link && (
        <a
          className="EfpaEurope-link"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fas fa-check-square"></i>
          Inscribirme ahora
        </a>
      )}
    </div>
  )
}
